import { apiWrapper } from "@ch/api";
import { KemUserSessionControllerService } from "@ch/generated";
import { handleError } from "./handleError";

interface GetKemUserSessionProps {
  userId: string;
}

const getKemUserSession = async ({ userId }: GetKemUserSessionProps) => {
  try {
    const response = await apiWrapper(() =>
      KemUserSessionControllerService.kemUserSessionControllerFindByUserId({
        userId,
      }),
    );
    return response;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export default getKemUserSession;
